import { mapKeys } from 'lodash-es';
import { ENVIRONMENT } from '../../environment';

export const MOVING_CENTER_FETCH_REQUEST = 'MOVING_CENTER_FETCH_REQUEST';
export const MOVING_CENTER_FETCH_SUCCESS = 'MOVING_CENTER_FETCH_SUCCESS';
export const MOVING_CENTER_FETCH_ERROR = 'MOVING_CENTER_FETCH_ERROR';

export const MOVING_CENTER_SUBMIT_REQUEST = 'MOVING_CENTER_SUBMIT_REQUEST';
export const MOVING_CENTER_SUBMIT_SUCCESS = 'MOVING_CENTER_SUBMIT_SUCCESS';
export const MOVING_CENTER_SUBMIT_ERROR = 'MOVING_CENTER_SUBMIT_ERROR';

export const MOVING_CENTER_REQUEST_REQUEST = 'MOVING_CENTER_REQUEST_REQUEST';
export const MOVING_CENTER_REQUEST_SUCCESS = 'MOVING_CENTER_REQUEST_SUCCESS';
export const MOVING_CENTER_REQUEST_ERROR = 'MOVING_CENTER_REQUEST_ERROR';

export const MOVING_CENTER_UPDATE_KIND_REQUEST =
  'MOVING_CENTER_UPDATE_KIND_REQUEST';
export const MOVING_CENTER_UPDATE_KIND_SUCCESS =
  'MOVING_CENTER_UPDATE_KIND_SUCCESS';
export const MOVING_CENTER_UPDATE_KIND_ERROR =
  'MOVING_CENTER_UPDATE_KIND_ERROR';

const BASE_URL = ENVIRONMENT.endpoints.salesforce;

export class MovingCenterActions {
  constructor($http) {
    'ngInject';
    this.$http = $http;
  }

  fetch(moveId) {
    return dispatch => {
      dispatch(createAction(MOVING_CENTER_FETCH_REQUEST));

      return this.$http
        .get(`${BASE_URL}/bookamove/preference?`, {
          params: salesforceify({ updater_move_id: moveId }),
        })
        .then(
          result =>
            dispatch(createAction(MOVING_CENTER_FETCH_SUCCESS, result.data)),
          err => {
            dispatch(createAction(MOVING_CENTER_FETCH_ERROR, err));
            throw err;
          }
        );
    };
  }

  submit(data) {
    return dispatch => {
      dispatch(createAction(MOVING_CENTER_SUBMIT_REQUEST));

      return this.$http
        .post(`${BASE_URL}/bookamove/preference`, salesforceify(data))
        .then(
          result =>
            dispatch(createAction(MOVING_CENTER_SUBMIT_SUCCESS, result.data)),
          err => {
            dispatch(createAction(MOVING_CENTER_SUBMIT_ERROR, err));
            throw err;
          }
        );
    };
  }

  request(data) {
    return dispatch => {
      dispatch(createAction(MOVING_CENTER_REQUEST_REQUEST));

      return this.$http
        .post(`${BASE_URL}/Moving_Center_Request__c`, salesforceify(data))
        .then(
          result =>
            dispatch(createAction(MOVING_CENTER_REQUEST_SUCCESS, result.data)),
          err => {
            dispatch(createAction(MOVING_CENTER_REQUEST_ERROR, err));
            throw err;
          }
        );
    };
  }

  updateMoveKind(kind, moveId) {
    return dispatch => {
      dispatch(createAction(MOVING_CENTER_UPDATE_KIND_REQUEST));

      return this.$http
        .post(
          `${BASE_URL}/bookamove/preference`,
          salesforceify({ kind, updater_move_id: moveId })
        )
        .then(
          result =>
            dispatch(
              createAction(MOVING_CENTER_UPDATE_KIND_SUCCESS, result.data)
            ),
          err => {
            dispatch(createAction(MOVING_CENTER_UPDATE_KIND_SUCCESS, err));
            throw err;
          }
        );
    };
  }
}

function createAction(type, payload, meta) {
  return {
    type,
    payload,
    meta,
  };
}

function salesforceify(object) {
  return mapKeys(object, (value, key) => `${key}__c`);
}
